import { CatIconZoomIn } from 'blocks-nextjs/blocks-react/components/Icons/ZoomIn';
import { CatIconZoomOut } from 'blocks-nextjs/blocks-react/components/Icons/ZoomOut';
import { CatButton } from 'components/blocks-components';
import { isValidZoom } from './utils';
import styles from './zoom-buttons.module.scss';
import cx from 'classnames';

type ZoomButtonsProps = {
  handleZoom: (zoom: number) => void;
  zoom: number;
  useNewIcons?: boolean;
};

const ZoomButtons = ({
  handleZoom,
  zoom,
  useNewIcons = false
}: ZoomButtonsProps) => {
  const isZoomOutDisabled = !isValidZoom(zoom - 1);
  const isZoomInDisabled = !isValidZoom(zoom + 1);

  const containerClasses = useNewIcons
    ? 'z-index-2 end-0 top-0 position-absolute me-0 mt-0'
    : 'row z-index-2 end-0 bottom-0 position-absolute me-2 mb-3';

  const flexDirection = useNewIcons ? 'flex-column' : 'flex-row';
  const buttonSpacing = useNewIcons ? 'mb-3' : 'me-3';

  return (
    <div className={containerClasses}>
      <div className={`d-flex ${flexDirection}`}>
        {useNewIcons ? (
          <>
            <CatButton
              className={buttonSpacing}
              hideText
              size="md"
              onClick={() => handleZoom(zoom + 1)}
              disabled={isZoomInDisabled}
              data-testid="zoomInButton"
            >
              <CatIconZoomIn slot="before" />
            </CatButton>
            <CatButton
              hideText
              size="md"
              onClick={() => handleZoom(zoom - 1)}
              disabled={isZoomOutDisabled}
              data-testid="zoomOutButton"
            >
              <CatIconZoomOut slot="before" />
            </CatButton>
          </>
        ) : (
          <>
            <button
              type="button"
              className={cx(buttonSpacing, styles['zoom-button'], {
                [styles['zoom-button--disabled']]: isZoomOutDisabled
              })}
              onClick={() => handleZoom(zoom - 1)}
              disabled={isZoomOutDisabled}
              data-testid="zoomOutButton"
            >
              <CatIconZoomOut slot="before" />
            </button>
            <button
              type="button"
              className={cx(styles['zoom-button'], {
                [styles['zoom-button--disabled']]: isZoomInDisabled
              })}
              onClick={() => handleZoom(zoom + 1)}
              disabled={isZoomInDisabled}
              data-testid="zoomInButton"
            >
              <CatIconZoomIn slot="before" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ZoomButtons;
